import { File } from '../lib/interfaces/File.interface'

const last = require('lodash/last')

export const getFileExtension = (file?: File) => {
  if (!file) {
    return null
  }

  return last(file.key.split('.')).toLowerCase()
}

export const getPureFileKey = (fileKey: string) => {
  let pureFileKey = fileKey
    const entityIdIndex = fileKey.indexOf('/')
    if (entityIdIndex >= 0) {
      pureFileKey = fileKey.substring(entityIdIndex + 1)
    }

    return pureFileKey
}

export const imageFileExtensions = ['jpg', 'jpeg', 'png']


// WEBPACK FOOTER //
// ./src/utils/files.ts